import React from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { useMediaQuery } from '@mantine/hooks';
import { useMantineTheme, Modal } from '@mantine/core';

const ScannerBarQRCodeModul = ({ stateData, fnClose, fnSuccess, fnFailed }) => {

    const qrCodeScannerRef = React.useRef(null);
    const theme = useMantineTheme();
    const matchesMaxXS = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

    React.useEffect(() => {
        if (stateData.show === true) {
            setTimeout(() => {
                qrCodeScannerRef.current = new Html5Qrcode('reader');

                const onScanSuccess = (decodedText, decodedResult) => {
                    stopScan();
                    fnSuccess(decodedText);
                };

                // const onScanFailure = (error) => {
                //     // handle scan failure, usually better to ignore and keep scanning.
                //     fnFailed(error);
                // }

                const config = { fps: 10, qrbox: 300 };

                qrCodeScannerRef.current.start({ facingMode: "environment" }, config, onScanSuccess);

                return () => {
                    const statusScan = qrCodeScannerRef.current.getState();

                    if (statusScan === 2 || statusScan === 3) {
                        qrCodeScannerRef.current.stop().then((ignore) => {
                            qrCodeScannerRef.current.clear();
                        }).catch((err) => {
                            //
                        })
                    }
                }
            }, 0);
        }
    }, [stateData.show, fnSuccess, fnFailed])

    const stopScan = () => {
        const statusScan = qrCodeScannerRef.current.getState();

        if (statusScan === 2 || statusScan === 3) {
            qrCodeScannerRef.current.stop().then((ignore) => {
                // QR Code scanning is stopped.
                qrCodeScannerRef.current.clear();
            }).catch((err) => {
                // Stop failed, handle it.
            })
        }
    }

    // const startScan = () => {
    //     if (stateData.show) {

    //         const statusScan = qrCodeScannerRef.current.getState();

    //         if (statusScan === 1 || statusScan === 3 || statusScan === 0) {

    //             qrCodeScannerRef.current = new Html5Qrcode('reader');

    //             const onScanSuccess = (decodedText, decodedResult) => {
    //                 console.log(`Scan result: ${decodedText}`, decodedResult);
    //                 setData(d => ({ ...d, res: decodedText + ' - ' + JSON.stringify(decodedResult) }))
    //             };

    //             const onScanFailure = (error) => {
    //                 // handle scan failure, usually better to ignore and keep scanning.
    //                 // for example:
    //                 // console.warn(`Code scan error = ${error}`);
    //             }

    //             const config = { fps: 10, qrbox: 300 };

    //             qrCodeScannerRef.current.start({ facingMode: "environment" }, config, onScanSuccess);

    //             console.log(qrCodeScannerRef.current.getState());
    //         } else {
    //             console.log('asd')
    //         }
    //     }
    // }

    return (
        <React.Fragment>
            <Modal
                opened={stateData.show}
                onClose={() => {
                    const statusScan = qrCodeScannerRef.current.getState();

                    if (statusScan === 1) {
                        // mencegah scanner yang belum sempurna di load. jika tidak sempurna di load, akan menyangkut dan camera device tidak bisa dimatikan.
                    } else {
                        stopScan();
                        fnClose(false);
                    }
                }}

                title="Scan Barcode"
                fullScreen={matchesMaxXS}
            >
                <div id="reader" />
            </Modal>
        </React.Fragment>
    )
}

export default ScannerBarQRCodeModul;